import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { AbstractFormFieldComponent } from '../../../PageBuilder/components/FormField/abstract-form-field.component';
import { ReportSeriesModel } from '../../models/report-series.model';
import { DropdownOptionModel } from '../../../Forms/models/dropdown-option.model';
import { GeographyTypesEnum } from '../../../../api/journodex/enum/geography-types.enum';
import { RegionPickerFieldService } from '../../services/region-picker-field.service';
import { MentionSearchModel } from '../../../../Monitor/Shared/models/mention-search.model';
import { JournodexRegionsService } from '../../../Journodex/services/journodex-regions.service';
import { GenericStyleModel } from '../../../Styles/models/generic-style.model';

@Component({
    selector: 'agpr-region-picker-field',
    templateUrl: './region-picker-field.component.html',
    styleUrls: ['./region-picker-field.component.scss'],
    standalone: false
})
export class RegionPickerFieldComponent extends AbstractFormFieldComponent implements OnInit, OnChanges {
    @Input() declare value: ReportSeriesModel[];

    geographyScaleOptions: DropdownOptionModel[] = [
        {
            label: 'Common.world',
            value: GeographyTypesEnum.world
        },
        {
            label: 'Common.country',
            value: GeographyTypesEnum.country
        }
    ];
    selectedGeographyScale: GeographyTypesEnum;
    selectedGeographyScaleOption: DropdownOptionModel = new DropdownOptionModel();
    regionOptions: DropdownOptionModel[] = [];

    selectedRegion: DropdownOptionModel;
    _series: ReportSeriesModel[];

    suggestions$: BehaviorSubject<DropdownOptionModel[]> = new BehaviorSubject<DropdownOptionModel[]>(null);

    regionOptionsPlaceholder: string;

    constructor(
        private regionPickerFieldService: RegionPickerFieldService,
        private journodexService: JournodexRegionsService
    ) {
        super();
    }

    ngOnInit() {
        this.updateSelectedOptions();
        this.changes.emit(this._series);
    }
    ngOnChanges(changes: SimpleChanges) {
        if (changes.hasOwnProperty('value')) {
            if (this.value && this.value.length > 0) {
                this._series = this.value;
            } else {
                this._series = this.getDefaultSeriesList();
            }
            this.updateSelectedOptions();
        }
    }

    /**
     * Updates the series with the selected options
     */
    updateSelectedOptions(): void {
        if (!this._series || !this._series.length) {
            return;
        }

        this._series.map(series => {
            if (!series.styles) {
                series.styles = new GenericStyleModel();
            }

            if (!series.styles.geographyScale) {
                series.styles.geographyScale = GeographyTypesEnum.world;
            }
        });
        this.selectedGeographyScale = <GeographyTypesEnum>this._series[0].styles.geographyScale;
        if (this.geographyScaleOptions && this.geographyScaleOptions.length > 0){
            this.selectedGeographyScaleOption = this.geographyScaleOptions.find(option => option.value === this.selectedGeographyScale);
        }
        const isoCode = this._series[0].styles.regionIsoCode + '';

        if (isoCode) {
            this.selectedRegion = this.regionOptions.find(option => {
                return option.value === isoCode;
            });
        }
        this.setRegionOptions();
    }

    setRegionOptions(): void {
        this.regionOptions = this.regionPickerFieldService.getRegionsAvailableForMapChart(this.selectedGeographyScale);
        this.suggestions$.next(this.regionOptions);
    }

    /**
     * Handles updates to geographyScale selected
     */
    scaleUpdated(event: GeographyTypesEnum): void {
        this.selectedRegion = null;
        this._series.map(series => {
            if (!series.styles) {
                series.styles = new GenericStyleModel();
            }
            series.styles.geographyScale = event;
            series.styles.regionIsoCode = '';
            series.mentions.filters = null;
        });

        switch (event) {
            case GeographyTypesEnum.world:
                this.regionOptionsPlaceholder = null;
                break;
            case GeographyTypesEnum.country:
                this.regionOptionsPlaceholder = 'Reports.selectCountry';
                break;
        }

        this.setRegionOptions();
        this.changes.emit(this._series);
    }

    /**
     * Handles updates to selected region
     */
    selectedRegionUpdated(geographyScale: GeographyTypesEnum): void {
        this.selectedGeographyScale = geographyScale;
        const id: number = +this.journodexService.getCountryByIsoCode('' + this.selectedRegion.value).id;
        this.journodexService.getRegions([id], GeographyTypesEnum.country).subscribe((regions) => {
            this._series.forEach(series => {
                if (!series.styles) {
                    series.styles = new GenericStyleModel();
                }
                series.styles.regionIsoCode = this.selectedRegion.value;
            });
            this.changes.emit(this._series);
        });
    }

    /**
     * Returns a new ReportSeriesModel[] with default values
     *
     * @returns ReportSeriesModel[]
     */
    getDefaultSeriesList(): ReportSeriesModel[] {
        let blockTypeKey = null;

        if (this.block && this.block.type && this.block.type.key) {
            blockTypeKey = this.block.type.key;
        }

        return [new ReportSeriesModel(null, blockTypeKey)];
    }
}
